import React from 'react';
import styled from 'styled-components';
import MediaQuery, { useMediaQuery } from 'react-responsive'
import ScrollAnimation from 'react-animate-on-scroll';

import about_bg from '../../Images/about_bg.png';
import about_bg_m from '../../Images/about_bg_m.png';
import about_img1 from '../../Images/about_img1.png';
import about_img2 from '../../Images/about_img2.png';
import about_img3 from '../../Images/about_img3.png';

import Kor from '../../whitepaper/KOR.pdf';
import Eng from '../../whitepaper/ENG.pdf';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-bottom: 280px;
  @media (max-width: 1210px) {
    background-color: #0A0C33;
  };
`
const SubContainer = styled.div`
  display: flex;
  width: 1170px;
  position: relative;
  z-index: 10;
  @media (max-width: 1210px) {
    width: 100%;
    background-color: white;
  };
`
const SubSubContainer = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: 970px;
  @media (max-width: 1010px) {
    width: 100%;
  }
`
const BgImg = styled.div`
  position: absolute;
  top: 380px;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 0;
  & > img {
    width: 4000px;
  }
  @media (max-width: 1210px) {
    top: 360px;
  }
  @media (max-width: 610px) {
    top: 480px;
  }
`
const TextBox = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-left: auto;
  width: 570px;
  /* margin-top: 385px; */
  & > button {
    margin-top: 40px;
    width: 240px;
    height: 50px;
    color: white;
    background-color: #090C32;
    cursor: pointer;
    font-size: 15px;
  }
  & > div:nth-child(1) {
    width: 100%;
    & > h2 {
      position: relative;
      text-align: left;
      font-weight: 400;
      font-size: 54px;
      letter-spacing: 0.05em;
      line-height: 140%;
      color: #090C32;
      z-index: 10;
    }
    & > div:nth-child(2) {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 0;
      width: 100%;
      & > h2 {
        margin-left: 3px;
        margin-top: 3px;
        -webkit-text-stroke: 2px #F600C1;
        color: transparent;
        position: relative;
        text-align: left;
        font-weight: 400;
        font-size: 54px;
        letter-spacing: 0.05em;
        line-height: 140%;
        z-index: 10;
      }
    }
  }
  & > div:nth-child(2) {
    & > p:nth-child(1) {
      margin-left: 5px;
      margin-top: 20px;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 0.05em;
      line-height: 160%;
    }
    & > p:nth-child(2) {
      margin-left: 5px;
      margin-top: 20px;
      font-size: 17px;
      font-weight: 200;
      letter-spacing: 0.05em;
      line-height: 180%;
    }
  }
  @media (max-width: 1210px) {
    width: 100%;
    margin-left: 0;
    padding: 0 20px;
    margin-top: 40px;
    justify-content: center;
    align-items: center;
    & > div:nth-child(1) {
      & > h2 {
        text-align: center;
      }
      & > div:nth-child(2) {
        display: flex;
        justify-content: center;
        & > h2 {
          text-align: center;
        }
      }
    }
    & > div:nth-child(2) {
      & > p {
        text-align: center;
      }
    }
  };
  @media (max-width: 430px) {
    & > div:nth-child(1) {
      & > h2 {
        font-size: 44px;
      }
      & > div:nth-child(2) {
        & > h2 {
          font-size: 44px;
        }
      }
    }
  };
`
const LeftImgContainer = styled.div`
  margin-top: 520px;  
  display: flex;
  flex-direction: row;
  width: 100%;
  & > img {
    width: 370px;
    object-fit: contain;
  }
  & > div {
    margin-left: auto;
    width: 470px;
    & > div {
      & > h2 {
        margin-top: 20px;
        color: white;
        font-size: 54px;
        line-height: 120%;
        & > span {
          font-family: 'Noto Sans';
        }
      }
    }
    & > div {
      & > p {
        margin-left: 5px;
        margin-top: 30px;
        font-size: 17px;
        font-weight: 200;
        letter-spacing: 0.05em;
        line-height: 180%;
        color: white;
      }
    }
  }
  @media (max-width: 1170px) {
    flex-direction: column;
    align-items: center;
    & > div {
      margin-left: 0;
      & > div {
        & > h2 {
          margin-top: 30px;
          text-align: center;
        }
      }
      & > div {
        & > p {
          text-align: center;
        }
      }
    }
  }
  @media (max-width: 510px) {
    margin-top: 420px;
    & > img {
      width: 80%;
    }
    & > div {
      width: 100%;
      padding: 0 20px;
      & > div {
        & > h2 {
          font-size: 44px;
        }
      }
    }
  }

`
const RightImgContainer = styled.div`
  margin-top: 270px;  
  display: flex;
  flex-direction: row;
  width: 100%;
  & > img {
    margin-left: auto;
    width: 370px;
  }
  & > div {
    width: 470px;
    & > div {
      & > h2 {
        margin-top: 20px;
        color: white;
        font-size: 54px;
        line-height: 120%;
        & > span {
          font-family: 'Noto Sans';
        }
      }
    }
    & > div {
      & > p {
        margin-left: 5px;
        margin-top: 30px;
        font-size: 17px;
        font-weight: 200;
        letter-spacing: 0.05em;
        line-height: 180%;
        color: white;
      }
    }
  }
`

const AboutContainer = ({ language }) => {
  const isBigScreen = useMediaQuery({ query: '(min-width: 510px)' })

  return (
    <Container>
      <SubContainer>
        <TextBox>
          <ScrollAnimation animateIn='fadeInUp'>
            <h2>What is GREX?</h2>
            <div>
              <h2>What is GREX?</h2>
            </div>
          </ScrollAnimation>
          <ScrollAnimation animateIn='fadeIn' duration="2">
            <p>P2E Game Reward Exchange Protocol on Blockchain</p>
            <p>{
              language === 'Korean' ?
                'GREX는 게임사가 자율적으로 게임화폐를 발행하여 플레이어에게 게임접속, 미션수행, 목표달성 등에 따라 리워드를 제공하고 플레이어는 차별화된 게임파이(Game-FI) 메커니즘을 통해 게임화폐를 다양한 가상자산으로 교환할 수 있는 블록체인 게임 리워드 및 환전 플랫폼입니다.'
                :
                'GREX is a blockchain game reward exchange platform with which game companies can issue game currency to provide players with rewards according to game access, mission performance, and goal achievement, and players can exchange game currency for various virtual assets through a differentiated Game-FI mechanism.'
            }</p>
          </ScrollAnimation>
          <button onClick={() => {
            window.open(language === 'Korean' ? Kor : Eng);
          }}>
            WHITEPAPER
          </button>
        </TextBox>
      </SubContainer>
      <SubSubContainer>
        <LeftImgContainer>
          <img alt="" src={about_img1} />
          <div>
            <ScrollAnimation animateIn='fadeInRight'>
              <h2>P<span>2</span>E Game Player is Angry!</h2>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeIn' duration="2">
              {
                language === 'Korean' ?
                  <p>요즘 게임사들이 재미있는 게임을 만들지 않고 토큰 경제를 구축하는 데만 전념하고 있습니다. ANGERLABS는 모든 게임들이 사용자의 재미에만 집중할 수 있도록 게임산업과 블록체인 암호화폐 시장을 연결하는, 새로운 생태계를 만들고 있습니다.</p>
                  :
                  <p>These days, game companies are just focusing on making a token economy without making fun games. ANGERLABS is making new ecosystem which connects game industry with blockchain cryptocurrency market so that all game companies can focus on user’s fun.</p>
              }
            </ScrollAnimation>
          </div>
        </LeftImgContainer>
        <MediaQuery minWidth={1170}>
          <RightImgContainer>
            <div>
              <ScrollAnimation animateIn='fadeInLeft'>
                <h2>For All Indie Games in the world!</h2>
              </ScrollAnimation>
              <ScrollAnimation animateIn='fadeIn' duration="2">
                {
                  language === 'Korean' ?
                    <p>블록체인 게임 인프라 구축은 많은 비용이 들어갑니다. 그래서 지금 P2E 게임 시장은 대형 게임사들이 주도하고 있습니다. 우리는 인디게임들이 쉽게 블록체인 P2E 서비스를 시작할 수 있는 기술을 개발합니다.</p>
                    :
                    <p>Making a blockchain game infrastructure costs a lot of money. So, large game companies lead the P2E game market. We develop technologies so that Indie Games can easily launch blockchain P2E services.</p>
                }
              </ScrollAnimation>
            </div>
            <img alt="" src={about_img2} />
          </RightImgContainer>
        </MediaQuery>
        <MediaQuery maxWidth={1170}>
          <LeftImgContainer style={{ marginTop: 270 }}>
            <img alt="" src={about_img2} />
            <div>
              <ScrollAnimation animateIn='fadeInRight'>
                <h2>For All Indie Games in the world!</h2>
              </ScrollAnimation>
              <ScrollAnimation animateIn='fadeIn' duration="2">
                {
                  language === 'Korean' ?
                    <p>블록체인 게임 인프라 구축은 많은 비용이 들어갑니다. 그래서 지금 P2E 게임 시장은 대형 게임사들이 주도하고 있습니다. 우리는 인디게임들이 쉽게 블록체인 P2E 서비스를 시작할 수 있는 기술을 개발합니다.</p>
                    :
                    <p>Making a blockchain game infrastructure costs a lot of money. So, large game companies lead the P2E game market. We develop technologies so that Indie Games can easily launch blockchain P2E services.</p>
                }
              </ScrollAnimation>
            </div>
          </LeftImgContainer>
        </MediaQuery>
        <LeftImgContainer style={{ marginTop: 270 }}>
          <img alt="" src={about_img3} style={{ width: !isBigScreen ? '90%' : 430, marginLeft: !isBigScreen ? 0 : -30 }} />
          <div>
            <ScrollAnimation animateIn='fadeInRight'>
              <h2>Autonomous Ecosystem for Games</h2>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeIn' duration="2">
              {
                language === 'Korean' ?
                  <p>개발자들은 GREX만의 게임파이 프로토콜을 이용하여 자율적인 P2E 생태계를 구축할 수 있습니다. 우리는 참여 게임의 네트워크 구축, 리워드 방법, 토큰 발행 등에 개입하지 않습니다. 플랫폼이 강력한 경제 프로토콜을 요구할수록 게임의 재미는 사라집니다.</p>
                  :
                  <p>Developers can make an autonomous P2E ecosystem using GREX's own Game-FI protocol. We do not intervene in making network of participatory games, reward methods, token issuance, etc. The more the platform needs a strong economic protocol, the less fun the game becomes.</p>
              }
            </ScrollAnimation>
          </div>
        </LeftImgContainer>
      </SubSubContainer>
      <MediaQuery minWidth={1210}>
        <BgImg>
          <img alt="" src={about_bg} />
        </BgImg>
      </MediaQuery>
      <MediaQuery maxWidth={1210}>
        <BgImg>
          <img alt="" src={about_bg_m} />
        </BgImg>
      </MediaQuery>
    </Container>
  )
}

export default AboutContainer;